export default { "columns":59,
 "image":"Newforestfloor.png",
 "imageheight":544,
 "imagewidth":959,
 "margin":0,
 "name":"image",
 "spacing":0,
 "tilecount":2006,
 "tiledversion":"1.11.0",
 "tileheight":16,
 "tiles":[
        {
         "id":86,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":145,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":152,
         "type":"ground"
        }, 
        {
         "id":153,
         "type":"ground"
        }, 
        {
         "id":196,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":197,
         "type":"ground"
        }, 
        {
         "id":198,
         "type":"ground"
        }, 
        {
         "id":203,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":211,
         "type":"ground"
        }, 
        {
         "id":212,
         "type":"ground"
        }, 
        {
         "id":254,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":255,
         "type":"ground"
        }, 
        {
         "id":256,
         "type":"ground"
        }, 
        {
         "id":257,
         "type":"ground"
        }, 
        {
         "id":262,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":270,
         "type":"ground"
        }, 
        {
         "id":271,
         "type":"ground"
        }, 
        {
         "id":305,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":306,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":307,
         "type":"ground"
        }, 
        {
         "id":308,
         "type":"ground"
        }, 
        {
         "id":311,
         "type":"ground"
        }, 
        {
         "id":312,
         "type":"ground"
        }, 
        {
         "id":313,
         "type":"ground"
        }, 
        {
         "id":314,
         "type":"ground"
        }, 
        {
         "id":315,
         "type":"ground"
        }, 
        {
         "id":316,
         "type":"ground"
        }, 
        {
         "id":319,
         "type":"ground"
        }, 
        {
         "id":320,
         "type":"ground"
        }, 
        {
         "id":329,
         "type":"ground"
        }, 
        {
         "id":330,
         "type":"ground"
        }, 
        {
         "id":356,
         "type":"ground"
        }, 
        {
         "id":357,
         "type":"ground"
        }, 
        {
         "id":358,
         "type":"ground"
        }, 
        {
         "id":362,
         "type":"ground"
        }, 
        {
         "id":363,
         "type":"ground"
        }, 
        {
         "id":364,
         "type":"ground"
        }, 
        {
         "id":365,
         "type":"ground"
        }, 
        {
         "id":366,
         "type":"ground"
        }, 
        {
         "id":367,
         "type":"ground"
        }, 
        {
         "id":370,
         "type":"ground"
        }, 
        {
         "id":371,
         "type":"ground"
        }, 
        {
         "id":372,
         "type":"ground"
        }, 
        {
         "id":373,
         "type":"ground"
        }, 
        {
         "id":374,
         "type":"ground"
        }, 
        {
         "id":375,
         "type":"ground"
        }, 
        {
         "id":378,
         "type":"ground"
        }, 
        {
         "id":379,
         "type":"ground"
        }, 
        {
         "id":388,
         "type":"ground"
        }, 
        {
         "id":389,
         "type":"ground"
        }, 
        {
         "id":415,
         "type":"ground"
        }, 
        {
         "id":416,
         "type":"ground"
        }, 
        {
         "id":421,
         "type":"ground"
        }, 
        {
         "id":422,
         "type":"ground"
        }, 
        {
         "id":423,
         "type":"ground"
        }, 
        {
         "id":424,
         "type":"ground"
        }, 
        {
         "id":425,
         "type":"ground"
        }, 
        {
         "id":426,
         "type":"ground"
        }, 
        {
         "id":429,
         "type":"ground"
        }, 
        {
         "id":430,
         "type":"ground"
        }, 
        {
         "id":431,
         "type":"ground"
        }, 
        {
         "id":432,
         "type":"ground"
        }, 
        {
         "id":433,
         "type":"ground"
        }, 
        {
         "id":434,
         "type":"ground"
        }, 
        {
         "id":437,
         "type":"ground"
        }, 
        {
         "id":438,
         "type":"ground"
        }, 
        {
         "id":440,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":-8,
                             "y":-16
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":447,
         "type":"ground"
        }, 
        {
         "id":448,
         "type":"ground"
        }, 
        {
         "id":449,
         "type":"ground"
        }, 
        {
         "id":450,
         "type":"ground"
        }, 
        {
         "id":454,
         "type":"ground"
        }, 
        {
         "id":455,
         "type":"ground"
        }, 
        {
         "id":456,
         "type":"ground"
        }, 
        {
         "id":457,
         "type":"ground"
        }, 
        {
         "id":458,
         "type":"ground"
        }, 
        {
         "id":474,
         "type":"ground"
        }, 
        {
         "id":475,
         "type":"ground"
        }, 
        {
         "id":480,
         "type":"ground"
        }, 
        {
         "id":481,
         "type":"ground"
        }, 
        {
         "id":482,
         "type":"ground"
        }, 
        {
         "id":488,
         "type":"ground"
        }, 
        {
         "id":489,
         "type":"ground"
        }, 
        {
         "id":490,
         "type":"ground"
        }, 
        {
         "id":496,
         "type":"ground"
        }, 
        {
         "id":497,
         "type":"ground"
        }, 
        {
         "id":499,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":506,
         "type":"ground"
        }, 
        {
         "id":507,
         "type":"ground"
        }, 
        {
         "id":508,
         "type":"ground"
        }, 
        {
         "id":509,
         "type":"ground"
        }, 
        {
         "id":513,
         "type":"ground"
        }, 
        {
         "id":514,
         "type":"ground"
        }, 
        {
         "id":515,
         "type":"ground"
        }, 
        {
         "id":516,
         "type":"ground"
        }, 
        {
         "id":517,
         "type":"ground"
        }, 
        {
         "id":539,
         "type":"ground"
        }, 
        {
         "id":540,
         "type":"ground"
        }, 
        {
         "id":541,
         "type":"ground"
        }, 
        {
         "id":542,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":550,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":557,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":-8,
                             "y":-16
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":572,
         "type":"ground"
        }, 
        {
         "id":573,
         "type":"ground"
        }, 
        {
         "id":574,
         "type":"ground"
        }, 
        {
         "id":575,
         "type":"ground"
        }, 
        {
         "id":576,
         "type":"ground"
        }, 
        {
         "id":600,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":608,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":616,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":742,
         "type":"ground"
        }, 
        {
         "id":743,
         "type":"ground"
        }, 
        {
         "id":744,
         "type":"ground"
        }, 
        {
         "id":745,
         "type":"ground"
        }, 
        {
         "id":746,
         "type":"ground"
        }, 
        {
         "id":794,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":795,
         "type":"ground"
        }, 
        {
         "id":796,
         "type":"ground"
        }, 
        {
         "id":801,
         "type":"ground"
        }, 
        {
         "id":802,
         "type":"ground"
        }, 
        {
         "id":803,
         "type":"ground"
        }, 
        {
         "id":804,
         "type":"ground"
        }, 
        {
         "id":805,
         "type":"ground"
        }, 
        {
         "id":853,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":854,
         "type":"ground"
        }, 
        {
         "id":855,
         "type":"ground"
        }, 
        {
         "id":860,
         "type":"ground"
        }, 
        {
         "id":861,
         "type":"ground"
        }, 
        {
         "id":862,
         "type":"ground"
        }, 
        {
         "id":863,
         "type":"ground"
        }, 
        {
         "id":864,
         "type":"ground"
        }, 
        {
         "id":904,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":905,
         "type":"ground"
        }, 
        {
         "id":906,
         "type":"ground"
        }, 
        {
         "id":911,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":912,
         "type":"ground"
        }, 
        {
         "id":913,
         "type":"ground"
        }, 
        {
         "id":914,
         "type":"ground"
        }, 
        {
         "id":954,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":955,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":8
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":956,
         "type":"ground"
        }, 
        {
         "id":957,
         "type":"ground"
        }, 
        {
         "id":962,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":963,
         "type":"ground"
        }, 
        {
         "id":970,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1005,
         "type":"ground"
        }, 
        {
         "id":1006,
         "type":"ground"
        }, 
        {
         "id":1011,
         "type":"ground"
        }, 
        {
         "id":1012,
         "type":"ground"
        }, 
        {
         "id":1013,
         "type":"ground"
        }, 
        {
         "id":1014,
         "type":"ground"
        }, 
        {
         "id":1015,
         "type":"ground"
        }, 
        {
         "id":1016,
         "type":"ground"
        }, 
        {
         "id":1019,
         "type":"ground"
        }, 
        {
         "id":1020,
         "type":"ground"
        }, 
        {
         "id":1021,
         "type":"ground"
        }, 
        {
         "id":1027,
         "type":"ground"
        }, 
        {
         "id":1028,
         "type":"ground"
        }, 
        {
         "id":1029,
         "type":"ground"
        }, 
        {
         "id":1064,
         "type":"ground"
        }, 
        {
         "id":1065,
         "type":"ground"
        }, 
        {
         "id":1070,
         "type":"ground"
        }, 
        {
         "id":1071,
         "type":"ground"
        }, 
        {
         "id":1072,
         "type":"ground"
        }, 
        {
         "id":1073,
         "type":"ground"
        }, 
        {
         "id":1074,
         "type":"ground"
        }, 
        {
         "id":1075,
         "type":"ground"
        }, 
        {
         "id":1086,
         "type":"ground"
        }, 
        {
         "id":1087,
         "type":"ground"
        }, 
        {
         "id":1088,
         "type":"ground"
        }, 
        {
         "id":1089,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1148,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1155,
         "type":"ground"
        }, 
        {
         "id":1156,
         "type":"ground"
        }, 
        {
         "id":1157,
         "type":"ground"
        }, 
        {
         "id":1158,
         "type":"ground"
        }, 
        {
         "id":1159,
         "type":"ground"
        }, 
        {
         "id":1160,
         "type":"ground"
        }, 
        {
         "id":1161,
         "type":"ground"
        }, 
        {
         "id":1162,
         "type":"ground"
        }, 
        {
         "id":1191,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1199,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1206,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1214,
         "type":"ground"
        }, 
        {
         "id":1215,
         "type":"ground"
        }, 
        {
         "id":1216,
         "type":"ground"
        }, 
        {
         "id":1217,
         "type":"ground"
        }, 
        {
         "id":1218,
         "type":"ground"
        }, 
        {
         "id":1219,
         "type":"ground"
        }, 
        {
         "id":1220,
         "type":"ground"
        }, 
        {
         "id":1221,
         "type":"ground"
        }, 
        {
         "id":1249,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1257,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1265,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1273,
         "type":"ground"
        }, 
        {
         "id":1274,
         "type":"ground"
        }, 
        {
         "id":1275,
         "type":"ground"
        }, 
        {
         "id":1276,
         "type":"ground"
        }, 
        {
         "id":1277,
         "type":"ground"
        }, 
        {
         "id":1278,
         "type":"ground"
        }, 
        {
         "id":1279,
         "type":"ground"
        }, 
        {
         "id":1280,
         "type":"ground"
        }, 
        {
         "id":1332,
         "type":"ground"
        }, 
        {
         "id":1333,
         "type":"ground"
        }, 
        {
         "id":1334,
         "type":"ground"
        }, 
        {
         "id":1335,
         "type":"ground"
        }, 
        {
         "id":1336,
         "type":"ground"
        }, 
        {
         "id":1337,
         "type":"ground"
        }, 
        {
         "id":1338,
         "type":"ground"
        }, 
        {
         "id":1339,
         "type":"ground"
        }, 
        {
         "id":1385,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1386,
         "type":"ground"
        }, 
        {
         "id":1387,
         "type":"ground"
        }, 
        {
         "id":1444,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1495,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1496,
         "type":"ground"
        }, 
        {
         "id":1497,
         "type":"ground"
        }, 
        {
         "id":1502,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1545,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1546,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":8
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1547,
         "type":"ground"
        }, 
        {
         "id":1548,
         "type":"ground"
        }, 
        {
         "id":1553,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1554,
         "type":"ground"
        }, 
        {
         "id":1555,
         "type":"ground"
        }, 
        {
         "id":1556,
         "type":"ground"
        }, 
        {
         "id":1561,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1595,
         "type":"ground"
        }, 
        {
         "id":1596,
         "type":"ground"
        }, 
        {
         "id":1597,
         "type":"ground"
        }, 
        {
         "id":1598,
         "type":"ground"
        }, 
        {
         "id":1602,
         "type":"ground"
        }, 
        {
         "id":1603,
         "type":"ground"
        }, 
        {
         "id":1604,
         "type":"ground"
        }, 
        {
         "id":1605,
         "type":"ground"
        }, 
        {
         "id":1606,
         "type":"ground"
        }, 
        {
         "id":1607,
         "type":"ground"
        }, 
        {
         "id":1610,
         "type":"ground"
        }, 
        {
         "id":1611,
         "type":"ground"
        }, 
        {
         "id":1612,
         "type":"ground"
        }, 
        {
         "id":1613,
         "type":"ground"
        }, 
        {
         "id":1614,
         "type":"ground"
        }, 
        {
         "id":1615,
         "type":"ground"
        }, 
        {
         "id":1618,
         "type":"ground"
        }, 
        {
         "id":1619,
         "type":"ground"
        }, 
        {
         "id":1654,
         "type":"ground"
        }, 
        {
         "id":1655,
         "type":"ground"
        }, 
        {
         "id":1656,
         "type":"ground"
        }, 
        {
         "id":1657,
         "type":"ground"
        }, 
        {
         "id":1661,
         "type":"ground"
        }, 
        {
         "id":1662,
         "type":"ground"
        }, 
        {
         "id":1663,
         "type":"ground"
        }, 
        {
         "id":1664,
         "type":"ground"
        }, 
        {
         "id":1665,
         "type":"ground"
        }, 
        {
         "id":1666,
         "type":"ground"
        }, 
        {
         "id":1669,
         "type":"ground"
        }, 
        {
         "id":1670,
         "type":"ground"
        }, 
        {
         "id":1671,
         "type":"ground"
        }, 
        {
         "id":1672,
         "type":"ground"
        }, 
        {
         "id":1673,
         "type":"ground"
        }, 
        {
         "id":1674,
         "type":"ground"
        }, 
        {
         "id":1680,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":-8,
                             "y":-16
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1739,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1782,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1790,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1797,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":-8,
                             "y":-16
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1840,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1848,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }, 
        {
         "id":1856,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            }
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};